import { Id, PagedMultiSelectField, laravelSelectFetchConfig } from "@dgs/core";
import { FC } from "react";
import { organizationalUnitService } from "../../api/organizationalUnitService";

const fetcher = (search: string, page: number, idToIgnore: Id | null) =>
	organizationalUnitService.options(search, page, { idToIgnore }).then((response) => response.data);

interface Props {
	name: string;
	label: string;
	required?: boolean;
	primaryOrganizationalUnitId: Id | null;
}

export const EventOrganizationalUnitMultiSelectField: FC<Props> = ({ primaryOrganizationalUnitId, ...props }) => {
	return (
		<PagedMultiSelectField
			{...props}
			fetchConfig={laravelSelectFetchConfig(
				organizationalUnitService.optionsKey.concat(`${primaryOrganizationalUnitId}`),
				(search, page) => fetcher(search, page, primaryOrganizationalUnitId),
			)}
		/>
	);
};
